// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import { Dropdown, Popover, Slideover } from 'tailwindcss-stimulus-components'
import AccordionController from '../../../components/ui/accordion/accordion_controller'
import AnimatedNumber from '@stimulus-components/animated-number'
import AssetUploadController from './asset_upload_controller'
import Autosubmit from '../../shared/controllers/autosubmit_controller'
import CharacterCounterController from '../../shared/controllers/character_counter_controller'
import Confirmation from '@stimulus-components/confirmation'
import CopyToClipboardController from './copy_to_clipboard_controller'
import Dialog from '@stimulus-components/dialog'
import DirectUploadController from '../../../components/ui/direct_upload/direct_upload_controller'
import HashcashController from './hashcash_controller'
import InputMask from '../../shared/controllers/input_mask_controller'
import LighboxController from './lightbox_controller'
import NavigationController from './navigation_controller'
import PasswordVisibility from '@stimulus-components/password-visibility'
import PayoutToggleController from './payout_toggle_controller'
import RadioUncheckController from '../../shared/controllers/radio_uncheck_controller'
import SortableController from '../../shared/controllers/sortable_controller'
import RadioFormValidationController from '../../shared/controllers/radio_form_validation_controller'
import RequiredFieldsValidationController from '../../shared/controllers/required_fields_validation_controller'
import StickyObserverController from './sticky_observer_controller'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import TimezoneController from './timezone_controller'
import ToastController from './toast_controller'
import TurboStreamController from '../../shared/controllers/turbo_stream_controller'

application.register('accordion', AccordionController)
application.register('animated-number', AnimatedNumber)
application.register('asset-upload', AssetUploadController)
application.register('autosubmit', Autosubmit)
application.register('character-counter', CharacterCounterController)
application.register('confirmation', Confirmation)
application.register('copy-to-clipboard', CopyToClipboardController)
application.register('dialog', Dialog)
application.register('direct-upload', DirectUploadController)
application.register('dropdown', Dropdown)
application.register('hashcash', HashcashController)
application.register('input-mask', InputMask)
application.register('lightbox', LighboxController)
application.register('navigation', NavigationController)
application.register('password-visibility', PasswordVisibility)
application.register('payout-toggle', PayoutToggleController)
application.register('popover', Popover)
application.register('radio-uncheck', RadioUncheckController)
application.register('slideover', Slideover)
application.register('sortable', SortableController)
application.register('radio-form-validation', RadioFormValidationController)
application.register('required-fields-validation', RequiredFieldsValidationController)
application.register('sticky-observer', StickyObserverController)
application.register('textarea-autogrow', TextareaAutogrow)
application.register('timezone', TimezoneController)
application.register('toast', ToastController)
application.register('turbo-stream', TurboStreamController)
